<template>
  <q-card class="mobile-video-container-card">
    <div class="mobile-picture-in-picture">
      <div
        class="move-to-session"
      >
        <q-btn
          color="black"
          round
          icon="arrow_back"
          text-color="white"
          size="md"
          class="mobile-video-chat-btn"
          @click="$emit('move-to-session-screen')"
        />

        <q-btn
          round
          color="black"
          text-color="white"
          icon="more_horiz"
          size="md"
          class="mobile-video-chat-btn"
        >
          <q-menu>
            <q-list style="min-width: 100px">
              <q-item
                v-ripple
                v-close-popup
                clickable
                @click="openSettings"
              >
                <q-item-section avatar>
                  <q-icon name="settings" />
                </q-item-section>
                <q-item-section class="text-no-wrap">
                  {{ $t('sessions.videoSession.controlVideoChatMenu.settings') }}
                </q-item-section>
              </q-item>
              <template v-if="isVideoSessionCreator && isRemoteParticipantConnected">
                <q-item
                  v-ripple
                  v-close-popup
                  clickable
                  @click="toggleZoomRemoteAudio"
                >
                  <q-item-section avatar>
                    <q-icon
                      :name="isRemoteParticipantOffAudio ? 'mic_off' : 'mic'"
                    />
                  </q-item-section>
                  <q-item-section class="text-no-wrap">
                    {{ isRemoteParticipantOffAudio
                      ? $t('sessions.videoSession.controlVideoChatMenu.unmuteAudio')
                      : $t('sessions.videoSession.controlVideoChatMenu.muteAudio')
                    }}
                  </q-item-section>
                </q-item>
                <q-item
                  v-ripple
                  v-close-popup
                  clickable
                  @click="controlRemoteParticipantVideoCall(isRemoteParticipantOffCamera ? 'video_on' : 'video_off')"
                >
                  <q-item-section avatar>
                    <q-icon :name="isRemoteParticipantOffCamera ? 'videocam_off' : 'videocam'" />
                  </q-item-section>
                  <q-item-section>
                    {{
                      isRemoteParticipantOffCamera
                        ? $t('sessions.videoSession.controlVideoChatMenu.turnOnVideo')
                        : $t('sessions.videoSession.controlVideoChatMenu.turnOffVideo')
                    }}
                  </q-item-section>
                </q-item>
                <q-item
                  v-ripple
                  v-close-popup
                  clickable
                  @click="controlRemoteParticipantVideoCall('disconnect')"
                >
                  <q-item-section avatar>
                    <q-icon name="call_end" />
                  </q-item-section>
                  <q-item-section>
                    {{ $t('sessions.videoSession.controlVideoChatMenu.disconnect') }}
                  </q-item-section>
                </q-item>
              </template>
            </q-list>
          </q-menu>
        </q-btn>
      </div>
      <video-player-container class="mobile-video-player-container">
        <div
          v-if="!camera"
          class="mobile-no-local-video"
        >
          <span class="material-icons">videocam_off</span>
        </div>
        <div
          v-if="isRemoteParticipantOffCamera"
          class="mobile-no-remote-video"
        >
          <span class="material-icons">person</span>
        </div>
        <div
          v-if="!isRemoteParticipantConnected"
          class="mobile-wait-participant-text"
        >
          <span>{{ waitingForUserText }}</span>
        </div>
      </video-player-container>
      <div
        v-if="isShowVideoCallPanel"
        class="mobile-participant-video"
      >
        <q-btn
          round
          color="black"
          text-color="white"
          size="md"
          :icon="isAudioOn ? 'mic' : 'mic_off'"
          class="mobile-video-chat-btn"
          @click="toggleZoomAudio"
        />
        <q-btn
          type="submit"
          round
          size="lg"
          icon="call_end"
          color="negative"
          text-color="white"
          :disable="!isActiveStream"
          @click="leaveCall"
        />
        <q-btn
          round
          color="black"
          text-color="white"
          size="md"
          :icon="camera ? 'videocam' : 'videocam_off'"
          class="mobile-video-chat-btn"
          @click="toggleZoomVideo"
        />
      </div>
    </div>
  </q-card>
</template>

<script>
import VideoSettings from 'components/VideoChat/Modals/VideoSettings';
import { mapState } from 'pinia';
import { IS_INVITATION_ACCEPTED } from 'src/constants/videoSession';
import Interactions from 'src/mixins/Interactions';
import VideoChat from 'src/mixins/VideoChat';
import { auth } from 'src/store/auth';
import { currentVideoSession } from 'src/store/currentVideoSession';

export default {
  name: 'MobileVideoContainer',

  mixins: [Interactions, VideoChat],

  props: {
    activeSession: {
      type: Object,
      default: () => ({}),
    },
    currentClient: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },

  emits: ['move-to-session-screen'],

  data() {
    return {};
  },

  computed: {
    ...mapState(auth, ['userDetails']),
    ...mapState(currentVideoSession, [
      'microphone',
      'camera',
      'isRemoteParticipantOffCamera',
      'isRemoteParticipantOffAudio',
      'isRemoteParticipantConnected',
    ]),

    isActiveStream() {
      return this.activeZoomStream !== null;
    },

    isAudioOn() {
      if (!this.isInvitedUser) {
        return this.microphone;
      }

      return this.microphone && !this.isRemoteParticipantOffAudio;
    },
  },

  methods: {
    showVideoCallRoom(invitedUser) {
      this.showRoom(invitedUser);
    }, // showVideoCallRoom()

    async leaveCall(method, force) {
      sessionStorage.removeItem(IS_INVITATION_ACCEPTED);
      await this.leaveZoomVideoCall(method, force);
    }, // leaveCall

    openSettings() {
      this.openComponentDialog(
        VideoSettings,
        {
          zoomClient: this.zoomVideoClient,
        },
        ({ camera, microphone, speaker }) => {
          this.updateDevices(camera, microphone, speaker);
        },
      );
    }, // openSettings()
  },
};
</script>

<style lang="scss">
.mobile-video-container-card {
  height: calc(100vh - 60px) !important;
  display: flex;
  flex-direction: column;

  .mobile-picture-in-picture {
    position: relative;
    width: 100%;
    height: 100%;
    .move-to-session {
      position: absolute;
      top: 30px;
      z-index: 3;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .q-btn {
        margin: 0 7px;
      }
    }
  }
  .mobile-participant-video {
    width: 100%;
    position: fixed;
    bottom: 20px;
    left: 0;
    right: 0;
    z-index: 1000;
    padding-bottom: env(safe-area-inset-bottom);
    display: flex;
    justify-content: center;
    align-items: center;
    .q-btn {
      margin: 0 5px;
    }
  }
}

.mobile-video-player-container {
  width: 100%;
  height: 100%;
  background-color: $dark;
}

.mobile-local-video {
  position: absolute;
  width: 25%;
  bottom: 120px;
  left: 5%;
  z-index: 5001;
  border-radius: 7px;
  aspect-ratio: 3 / 4;

  video {
    object-fit: cover;
    display: block;
  }
}

.mobile-local-video.active-speaker {
  border: #1494F0 3px solid;
}

.mobile-remote-video {
  height: 100%;
  width: 100%;
  object-fit: cover;

  video {
    display: block;
  }
}

.mobile-remote-video.active-speaker {
  box-sizing: border-box;
  border: #1494F0 3px solid;
}

.mobile-no-local-video {
  position: absolute;
  width: 25%;
  bottom: 120px;
  left: 5%;
  height: auto;
  min-height: 160px;
  background: $grey-10;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  z-index: 5001;
  span {
    color: white;
    font-size: 24px;
  }
}

.mobile-no-remote-video {
  position: absolute;
  background: $dark;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  span {
    color: white;
    font-size: 48px;
  }
}

.mobile-wait-participant-text {
  position: absolute;
  background: white;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

.hide-video {
  display: none;
}

.mobile-video-chat-btn {
  opacity: 40%;
}
</style>
